const normalizeNavPath = (path) => {
	if (!path || path === '#') {
		return null;
	}

	try {
		const url = new URL(path, window.location.origin);
		const normalized = url.pathname.replace(/\/+$/, '') || '/';
		return normalized;
	} catch {
		return null;
	}
};

const markHeaderNavCurrent = (nav) => {
	const currentPath = normalizeNavPath(window.location.pathname);
	if (!currentPath) {
		return;
	}

	nav.querySelectorAll('a.site-header__nav-link').forEach((link) => {
		const linkPath = normalizeNavPath(link.getAttribute('href'));
		const isCurrent =
			Boolean(linkPath) &&
			(linkPath === currentPath ||
				(linkPath !== '/' && currentPath.startsWith(`${linkPath}/`)));

		link.classList.toggle('is-active', isCurrent);

		if (isCurrent) {
			link.setAttribute('aria-current', 'page');
			return;
		}

		link.removeAttribute('aria-current');
	});
};

window.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.site-header');
	const burger = document.querySelector('.js-burger');
	const nav = document.querySelector('.js-nav');
	const overlay = document.querySelector('.js-header-overlay');
	const body = document.body;

	if (nav) {
		markHeaderNavCurrent(nav);
	}

	if (!burger || !nav || !overlay) {
		return;
	}
	const desktopQuery = window.matchMedia('(min-width: 1400px)');

	const syncNavAccessibility = () => {
		if (desktopQuery.matches) {
			nav.removeAttribute('aria-hidden');
			return;
		}
		nav.setAttribute('aria-hidden', nav.classList.contains('is-active') ? 'false' : 'true');
	};

	const closeServicesMegaPanels = () => {
		nav.querySelectorAll('.site-header__nav-item--services-mega.is-open').forEach((item) => {
			item.classList.remove('is-open');
			const trigger = item.querySelector('.js-services-mega-trigger');
			trigger?.setAttribute('aria-expanded', 'false');
		});
	};

	const setMenuOpen = (open) => {
		burger.classList.toggle('is-active', open);
		nav.classList.toggle('is-active', open);
		overlay.classList.toggle('is-active', open);
		body.classList.toggle('menu-show', open);
		burger.setAttribute('aria-expanded', open ? 'true' : 'false');
		nav.setAttribute('aria-hidden', open ? 'false' : 'true');
		overlay.hidden = !open;
		overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
		burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
		if (!open) {
			closeServicesMegaPanels();
		}
		syncNavAccessibility();
	};

	const closeMenu = () => setMenuOpen(false);

	const servicesMegaBridgePx = 48;
	const servicesMegaCloseDelayMs = 200;

	const isWithinServicesMegaHover = (item, mega, bridge, node) => {
		if (!node || !(node instanceof Node)) {
			return false;
		}

		return item.contains(node) || mega.contains(node) || (bridge?.contains(node) ?? false);
	};

	const syncServicesMegaBridge = (item) => {
		const bridge = item.querySelector('.js-services-mega-hover-bridge');
		const dropdown = item.querySelector('.site-header__nav-dropdown');
		const mega = item.querySelector('.js-services-mega');

		if (!bridge || !dropdown || !mega || !header) {
			return;
		}

		if (!desktopQuery.matches) {
			bridge.style.cssText = '';
			return;
		}

		const dropdownRect = dropdown.getBoundingClientRect();
		const megaTop = Math.round(header.getBoundingClientRect().bottom) - servicesMegaBridgePx;
		const bridgeTop = Math.round(dropdownRect.bottom);
		const bridgeHeight = Math.max(0, megaTop + servicesMegaBridgePx - bridgeTop);

		bridge.style.top = `${bridgeTop}px`;
		bridge.style.left = `${Math.round(dropdownRect.left)}px`;
		bridge.style.width = `${Math.round(dropdownRect.width)}px`;
		bridge.style.height = `${bridgeHeight}px`;
	};

	const syncServicesMegaTop = () => {
		if (!header) {
			return;
		}
		const top = Math.round(header.getBoundingClientRect().bottom) - servicesMegaBridgePx;
		document.documentElement.style.setProperty('--services-mega-top', `${top}px`);
		nav.querySelectorAll('.site-header__nav-item--services-mega').forEach((item) => {
			syncServicesMegaBridge(item);
		});
	};

	const closeDesktopServicesMega = () => {
		nav.querySelectorAll('.site-header__nav-item--services-mega.is-services-mega-open').forEach((item) => {
			item.classList.remove('is-services-mega-open');
			item.querySelector('.js-services-mega')?.classList.remove('is-active');
			item.querySelector('.js-services-mega-trigger')?.setAttribute('aria-expanded', 'false');
		});
		header?.classList.remove('is-services-mega-open');
	};

	const initServicesMegaHover = () => {
		if (!header) {
			return;
		}

		const closeTimers = new WeakMap();

		const syncHeaderMegaState = () => {
			const anyOpen = nav.querySelector('.site-header__nav-item--services-mega.is-services-mega-open');
			header.classList.toggle('is-services-mega-open', Boolean(anyOpen));
		};

		const setServicesMegaOpen = (item, open) => {
			const trigger = item.querySelector('.js-services-mega-trigger');
			const mega = item.querySelector('.js-services-mega');

			item.classList.toggle('is-services-mega-open', open);
			syncHeaderMegaState();
			mega?.classList.toggle('is-active', open);
			trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
		};

		const clearCloseTimer = (item) => {
			const timer = closeTimers.get(item);
			if (timer) {
				window.clearTimeout(timer);
				closeTimers.delete(item);
			}
		};

		const scheduleServicesMegaClose = (item) => {
			clearCloseTimer(item);
			closeTimers.set(
				item,
				window.setTimeout(() => {
					setServicesMegaOpen(item, false);
					closeTimers.delete(item);
				}, servicesMegaCloseDelayMs),
			);
		};

		nav.querySelectorAll('.site-header__nav-item--services-mega').forEach((item) => {
			const mega = item.querySelector('.js-services-mega');
			const bridge = item.querySelector('.js-services-mega-hover-bridge');
			if (!mega) {
				return;
			}

			const open = () => {
				if (!desktopQuery.matches) {
					return;
				}

				syncServicesMegaBridge(item);

				nav.querySelectorAll('.site-header__nav-item--services-mega.is-services-mega-open').forEach((other) => {
					if (other !== item) {
						clearCloseTimer(other);
						setServicesMegaOpen(other, false);
					}
				});

				clearCloseTimer(item);
				setServicesMegaOpen(item, true);
			};

			[item, mega, bridge].filter(Boolean).forEach((target) => {
				target.addEventListener('mouseenter', open);
				target.addEventListener('mouseleave', (event) => {
					if (isWithinServicesMegaHover(item, mega, bridge, event.relatedTarget)) {
						return;
					}
					scheduleServicesMegaClose(item);
				});
			});

			item.addEventListener('focusin', open);
			item.addEventListener('focusout', (event) => {
				if (!desktopQuery.matches) {
					return;
				}
				if (item.contains(event.relatedTarget)) {
					return;
				}
				scheduleServicesMegaClose(item);
			});
		});
	};

	burger.addEventListener('click', () => {
		setMenuOpen(!nav.classList.contains('is-active'));
	});

	overlay.addEventListener('click', closeMenu);

	nav.querySelectorAll('a.site-header__nav-link').forEach((link) => {
		link.addEventListener('click', () => {
			closeDesktopServicesMega();
			closeMenu();
		});
	});

	nav.querySelectorAll('.js-services-mega-trigger').forEach((trigger) => {
		const item = trigger.closest('.site-header__nav-item--services-mega');
		if (!item) {
			return;
		}

		const toggleMobilePanel = (event) => {
			if (desktopQuery.matches) {
				return;
			}

			event.preventDefault();
			const isOpen = item.classList.contains('is-open');

			closeServicesMegaPanels();

			if (!isOpen) {
				item.classList.add('is-open');
				trigger.setAttribute('aria-expanded', 'true');
				return;
			}

			trigger.setAttribute('aria-expanded', 'false');
		};

		trigger.addEventListener('click', toggleMobilePanel);

		// #110: the label ("Leistungen") sits in the same row as the chevron
		// and visually reads as one tappable control, but it's a plain <span>
		// with no handler of its own — only the chevron button responded.
		item.querySelector('.site-header__nav-link--dropdown')?.addEventListener('click', toggleMobilePanel);
	});

	nav.querySelectorAll('.services-mega__card').forEach((link) => {
		link.addEventListener('click', () => {
			if (!desktopQuery.matches) {
				closeMenu();
			}
		});
	});

	window.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			closeDesktopServicesMega();
			closeServicesMegaPanels();
			closeMenu();
		}
	});

	desktopQuery.addEventListener('change', () => {
		closeServicesMegaPanels();
		closeDesktopServicesMega();
		if (desktopQuery.matches) {
			closeMenu();
		}
		syncNavAccessibility();
		syncServicesMegaTop();
	});

	window.addEventListener('scroll', syncServicesMegaTop, { passive: true });
	window.addEventListener('resize', syncServicesMegaTop, { passive: true });

	syncNavAccessibility();
	syncServicesMegaTop();
	initServicesMegaHover();
});
